<h1 mat-dialog-title class="pt-2 text-center"> Prochaine stratégies </h1>
<div mat-dialog-content class="p-0">

    <div class="row">
        @for (s of StrategyList; track s) {
        <div class="col-12 col-sm-6 col-xl-4 text-center border rounded-1 p-3">
            <div class="row align-items-center justify-content-around">
                <div class="col fw-bold">{{s.Id}} {{s.Portfolio.SamplingPointName}} {{s.Portfolio.SamplingPointZipCode}} {{s.Portfolio.SamplingPointCity}} {{s.Portfolio.ClientName}}</div>
            </div>
            <div class="row">
                <div class="col">
                    {{s.UpcomingAVT}}
                </div>
            </div>
        </div>
        }
    </div>

    <div class="row m-1">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
            Annuler
        </button>
        <button appPreventDoubleClick class="col ms-1" mat-raised-button color="primary" (throttledClick)="finish()">
            Enregistrer
        </button>
    </div>
</div>